// 上报白名单
function lookUpOptions(code) {
  const { value = [] } = Array.isArray(window.__ERPLOOKUP__) ? window.__ERPLOOKUP__.find(ele => ele.code === code) : {}
  return value
}
const CONF = [
  {
    tag: 'query-table',
    name: 'queryTable'
  },
  {
    tag: 'table-list',
    name: 'table-list'
  },
  {
    tag: 'custom-filter',
    name: '通用查询'
  },
  {
    tag: 'search-pager',
    name: '搜索页'
  },
  {
    tag: 'dept-dialog',
    name: '组织树'
  },
  {
    tag: 'kye-area-select',
    name: '区域组件'
  },
  {
    tag: 'kye-search-tips',
    name: '搜索输入框'
  },
  {
    tag: 'kye-decrypt',
    name: '加解密组件'
  },
  {
    tag: 'kye-editor-new',
    name: '富文本组件'
  },
  {
    tag: 'kye-image',
    name: '图片预览'
  },
  {
    tag: 'kye-field-call',
    name: '座机打电话'
  },
  {
    tag: 'kye-upload',
    name: '上传'
  },
  {
    tag: 'ElBreadcrumb',
    name: '面包屑'
  },
  {
    tag: 'ElPagination',
    name: '分页器'
  },
  {
    tag: 'ElTable',
    name: 'el-表格'
  },
  {
    tag: 'kye-edit-table',
    name: '编辑表格'
  },
  {
    tag: 'kye-date-picker',
    name: 'kye-日期组件'
  },
  {
    tag: 'kye-form',
    name: 'kye-表单组件'
  },
  {
    tag: 'el-dialog',
    name: '弹窗组件'
  },
  {
    tag: 'access-statistic-number',
    name: '访问统计组件'
  },
  {
    tag: 'ElTimeSelect',
    name: '时间选择器'
  },
  {
    tag: 'kye-time-picker',
    name: '时间输入器'
  },
  {
    tag: 'ElTimePicker',
    name: '时间输入器'
  },
  {
    tag: 'kye-number',
    name: 'kye-number'
  },
  {
    tag: 'ElBadge',
    name: 'el-badge'
  },
  {
    tag: 'kye-data-export',
    name: '导出'
  },
  {
    tag: 'kye-data-import',
    name: '导入'
  },
  {
    tag: 'kye-preview',
    name: '预览'
  },
  {
    tag: 'ElTag',
    name: 'Tag 标签'
  },
  {
    tag: 'ElTabs',
    name: '标签页'
  },
  {
    tag: 'ElPopover',
    name: '气泡提示组件'
  },
  {
    tag: 'ElStep',
    name: '步骤条组件'
  },
  {
    tag: 'kye-time-select',
    name: '时间选择器'
  },
  {
    tag: 'KyeDrawer',
    name: '抽屉组件'
  },
  {
    tag: 'kye-virtual-list',
    name: '虚拟列表'
  },
]

let whiteList = lookUpOptions('sys_component_report')
whiteList = (whiteList && whiteList.map(ele => ({tag: ele.lookupValue}))) || CONF

export { whiteList }




// WEBPACK FOOTER //
// ./src/public/mixins/component-report/conf.js